/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SecureFileVersionResponse } from './SecureFileVersionResponse';
import {
    SecureFileVersionResponseFromJSON,
    SecureFileVersionResponseFromJSONTyped,
    SecureFileVersionResponseToJSON,
    SecureFileVersionResponseToJSONTyped,
} from './SecureFileVersionResponse';

/**
 * 
 * @export
 * @interface SecureFileResponse
 */
export interface SecureFileResponse {
    /**
     * 
     * @type {string}
     * @memberof SecureFileResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SecureFileResponse
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof SecureFileResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SecureFileResponse
     */
    currentVersionId?: string;
    /**
     * 
     * @type {Date}
     * @memberof SecureFileResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SecureFileResponse
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof SecureFileResponse
     */
    updatedAt?: Date;
    /**
     * 
     * @type {SecureFileVersionResponse}
     * @memberof SecureFileResponse
     */
    currentVersion?: SecureFileVersionResponse;
    /**
     * 
     * @type {boolean}
     * @memberof SecureFileResponse
     */
    externalStorage?: boolean;
}

/**
 * Check if a given object implements the SecureFileResponse interface.
 */
export function instanceOfSecureFileResponse(value: object): value is SecureFileResponse {
    return true;
}

export function SecureFileResponseFromJSON(json: any): SecureFileResponse {
    return SecureFileResponseFromJSONTyped(json, false);
}

export function SecureFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecureFileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'name': json['name'] == null ? undefined : json['name'],
        'currentVersionId': json['currentVersionId'] == null ? undefined : json['currentVersionId'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'currentVersion': json['currentVersion'] == null ? undefined : SecureFileVersionResponseFromJSON(json['currentVersion']),
        'externalStorage': json['externalStorage'] == null ? undefined : json['externalStorage'],
    };
}

export function SecureFileResponseToJSON(json: any): SecureFileResponse {
    return SecureFileResponseToJSONTyped(json, false);
}

export function SecureFileResponseToJSONTyped(value?: SecureFileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'name': value['name'],
        'currentVersionId': value['currentVersionId'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'currentVersion': SecureFileVersionResponseToJSON(value['currentVersion']),
        'externalStorage': value['externalStorage'],
    };
}

